import { getGoogleTokenForVariant } from "@/utils/googlePricing";
import type { CartProduct } from "@features/product/utils/toCartProduct";
import type { CartItemInput } from "@repo/core/cart";

export default function createCartItem({
  product,
  ...props
}: Partial<CartItemInput> & {
  product: CartProduct;
}): CartItemInput {
  return {
    partNo: product.partNo,
    vatRate: product.vatRate,
    quantity: product.quantity,
    googlePv2Token: getGoogleTokenForVariant(product.partNo),
    ...props,
    extras: {
      variant: product.name,
      product_url: product.link,
      stock_status: product.itemStatus,
      ...props.extras,
    },
  };
}
